module.exports = __webpack_public_path__ + "img/avatar1.666e2892.png";